<template>
    <v-card flat>
        <!-- SEARCH TEXT CARD -->
        <v-card flat style="width:500px;margin:auto;margin-top:10px" color="white">
            <!--            <v-img
                            src="https://valesco.es/sites/default/files/logo_web_4.png"
                            height="200px"
                            ></v-img>-->

            <v-container style="height:160px;overflow: hidden" class="pa-0">
                <v-row class="pa-0 ma-0" justify="center">
                    <v-col cols="10" align-self="center">
                        <v-text-field v-if="debugTextSearch" id="regexInput" class="mb-2" v-model="search_regex"
                            label="Regex expression" @keydown.enter="doSearch" height="35" solo rounded
                            hide-details="true" value="">
                        </v-text-field>
                        <v-text-field class="mb-2" v-model="search_words" label="Buscar palabras"
                            @keydown.enter="doSearch"
                            hint="Escriba las palabras que desea buscar separadas por espacios. Separe las palabras con (|) para indicar opcionalidad. Utilice (?) para indicar que la palabra buscada puede tener cualquier carácter de palabra en esa posición. Utilice (*) para obtener cualquier sucesión de caracteres de palabra."
                            height="35" solo rounded>
                            <template v-slot:prepend-inner>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" @click="doSearch">search</v-icon>
                                    </template>
                                    "Buscar estas palabras en las documentos"
                                </v-tooltip>
                            </template>
                            <template v-slot:append>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" @click="search_words = ''">close</v-icon>
                                    </template>
                                    "Borrar texto"
                                </v-tooltip>
                            </template>

                            <v-icon slot="append" @click="search_words = ''">
                                close
                            </v-icon>
                        </v-text-field>
                    </v-col>
                    <v-col class="" align-self="start" cols="2">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-6" v-on="on" @click.stop="filters_dialog = true">
                                    <v-icon color="black">mdi-filter</v-icon>
                                </v-btn>
                            </template>
                            "Definir filtros de búsqueda"
                        </v-tooltip>
                        <v-dialog v-model="filters_dialog" max-width="650">
                            <!-- FILTERS SECTION -->
                            <v-container class="pa-0" fluid>
                                <!--style="width:650px"-->
                                <v-row no-gutters justify="center">
                                    <v-col cols="12" class="pa-0">
                                        <v-card class="pa-5 filter-color">
                                            <v-card-title class="filter-color py-0" style="min-height:10px" hide-actions
                                                dense>
                                                <h3 class="filter-color font-weight-bold text-center"
                                                    style="line-height:10px">
                                                    Opciones de búsqueda
                                                </h3>
                                            </v-card-title>

                                            <v-card-text class="filter-color pa-0 ma-0"
                                                style="padding:0px !important;font-size:90%">
                                                <v-toolbar class="filter-color" dense flat>
                                                    <v-tabs v-model="selected_entity_tab" height="35">
                                                        <v-tab v-for="searchFilter in search_filters"
                                                            :key="searchFilter['id']"
                                                            :href="'#tab-' + searchFilter['id']" small class="px-2"
                                                            dense>
                                                            <v-icon dense left>{{ searchFilter.icon }}</v-icon>
                                                            {{ searchFilter.name }}
                                                        </v-tab>
                                                    </v-tabs>
                                                </v-toolbar>

                                                <v-tabs-items v-model="selected_entity_tab">
                                                    <v-tab-item v-for="searchFilter in search_filters"
                                                        :key="searchFilter['id']" :value="'tab-' + searchFilter['id']">

                                                        <!-- OPTIONS SECTION -->
                                                        <v-container v-if="searchFilter['id'] === 'options'"
                                                            class="filter-color pa-0" fluid>
                                                            <v-card class="filter-row-color my-0 mb-2 pa-1" outlined>
                                                                <v-row no-gutters>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Buscar por
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-btn-toggle
                                                                            v-model="filterForm['options']['token_mode']"
                                                                            dense mandatory>
                                                                            <v-btn color="white" :value="'shape'" small>
                                                                                Forma
                                                                            </v-btn>
                                                                            <v-btn color="white" :value="'lemma'" small>
                                                                                Lema
                                                                            </v-btn>
                                                                        </v-btn-toggle>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        considerar
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-btn-toggle
                                                                            v-model="filterForm['options']['capital_mode']"
                                                                            dense>
                                                                            <v-btn color="white" :value="'uppercase'"
                                                                                small>
                                                                                Mayúsculas
                                                                            </v-btn>
                                                                            <!--                                                            <v-btn
                                                                                                                                            color="white"  
                                                                                                                                            :value="'lowercase'"
                                                                                                                                            small>
                                                                                                                                            Minúsculas
                                                                                                                                        </v-btn>-->
                                                                        </v-btn-toggle>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        /
                                                                    </v-col>
                                                                    <v-col class="search-value-col px-0" cols="auto">
                                                                        <v-btn-toggle
                                                                            v-model="filterForm['options']['accents']"
                                                                            dense>
                                                                            <v-btn color="white" :value="'accents'"
                                                                                small>
                                                                                Acentos
                                                                            </v-btn>
                                                                        </v-btn-toggle>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                            <v-card class="filter-row-color mb-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Aparece
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-btn-toggle
                                                                            v-model="filterForm['options']['filter_position']"
                                                                            dense>
                                                                            <v-btn color="white" :value="'preceded'"
                                                                                small>
                                                                                <!--<v-icon>mdi-format-align-center</v-icon>-->
                                                                                Precedido
                                                                            </v-btn>
                                                                            <v-btn color="white" :value="'followed'"
                                                                                small>
                                                                                <!--<v-icon>mdi-format-align-left</v-icon>-->
                                                                                Seguido
                                                                            </v-btn>
                                                                            <v-btn color="white" :value="'both'" small>
                                                                                <!--<v-icon>mdi-format-align-left</v-icon>-->
                                                                                ambos
                                                                            </v-btn>
                                                                        </v-btn-toggle>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        por
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-btn-toggle
                                                                            v-model="filterForm['options']['filter_position_char']"
                                                                            dense>
                                                                            <v-btn color="white"
                                                                                :value="'exclamation_mark'" small>
                                                                                !¡
                                                                            </v-btn>
                                                                            <v-btn color="white"
                                                                                :value="'question_marks'" small>
                                                                                ¿?
                                                                            </v-btn>
                                                                            <v-btn color="white" :value="'slash'" small>
                                                                                /
                                                                            </v-btn>
                                                                        </v-btn-toggle>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                            <v-card class="filter-row-color mb-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters>
                                                                    <v-col cols="12">
                                                                        Clase de palabra
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['word_type']"
                                                                            :items="word_types" dense solo outlined
                                                                            hide-details="true"
                                                                            @change="resetWordTypeSection()"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isPronomTypeVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Tipo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete v-model="c"
                                                                            :items="pronom_types" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isDetTypeVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Tipo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['type']"
                                                                            :items="det_types" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isSustTypeVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Tipo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['type']"
                                                                            :items="sust_types" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isPronomSubtypeVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Subtipo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['word_type']"
                                                                            :items="pronom_subtypes" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isPersonVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Persona
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['person']"
                                                                            :items="persons" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isGenreVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Género
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['genre']"
                                                                            :value="filterForm['options']['genre']"
                                                                            :items="genres" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isNumberVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Número
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['number']"
                                                                            :items="numbers" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isMoodVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Modo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['mood']"
                                                                            :items="moods" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isTenseVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Tiempo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['tense']"
                                                                            :items="tenses" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-container>

                                                        <!-- METADATA SECTION -->
                                                        <v-container v-if="searchFilter['id'] === 'metadata'"
                                                            class="filter-color pa-0" fluid>
                                                            <v-card class="filter-row-color my-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters>
                                                                    <!--{{corpus_documents}}-->
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Buscar en conversación
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['metadata']['corpus_document']"
                                                                            :items="documents" item-text="name"
                                                                            item-value="cod" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row no-gutters>
                                                                    <!--{{corpus_documents}}-->
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Tipo de conversación
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['metadata']['corpus_document_type']"
                                                                            :items="corpusDocumentTypes"
                                                                            item-text="name" item-value="cod" dense solo
                                                                            outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                            <v-card class="filter-row-color my-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Buscar entre los años
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="2">
                                                                        <v-text-field
                                                                            v-model="filterForm['metadata']['year_init']"
                                                                            outlined class="filterForm-input"
                                                                            hide-details="true" dense solo>
                                                                        </v-text-field>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        y
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="2">
                                                                        <v-text-field
                                                                            v-model="filterForm['metadata']['year_end']"
                                                                            outlined hide-details="true" solo dense>
                                                                        </v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                            <v-card class="filter-row-color my-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters justify="start">
                                                                    <v-col class="search-label-col" cols="12">
                                                                        Buscar hablante
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Género
                                                                    </v-col>
                                                                    <v-col cols="2" class="search-value-col mr-2">
                                                                        <v-radio-group class="mt-0"
                                                                            v-model="filterForm['metadata']['speaker_genre']"
                                                                            hide-details="true" color="purple" row
                                                                            dense>
                                                                            <v-radio style="" dense label="Hombre"
                                                                                value="H">
                                                                            </v-radio>
                                                                            <v-radio label="Mujer" value="M">
                                                                            </v-radio>
                                                                        </v-radio-group>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Nivel educativo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-combobox
                                                                            v-model="filterForm['metadata']['educational_level']"
                                                                            :items="educationalLevels" item-value="cod"
                                                                            item-text="name" outlined dense
                                                                            hide-details="true" solo>
                                                                        </v-combobox>
                                                                    </v-col>
                                                                    <v-spacer></v-spacer>
                                                                </v-row>
                                                                <v-row no-gutters justify="start">
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Profesión
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-combobox class="mr-3"
                                                                            v-model="filterForm['metadata']['profession']"
                                                                            :items="professions" item-value="cod"
                                                                            item-text="name" outlined dense
                                                                            hide-details="true" solo>
                                                                        </v-combobox>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Nivel Sociocultural
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-combobox
                                                                            v-model="filterForm['metadata']['instruction_level']"
                                                                            :items="instructionLevels" item-value="cod"
                                                                            item-text="name" outlined dense
                                                                            hide-details="true" solo>
                                                                        </v-combobox>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row no-gutters justify="start">
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Idioma
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-combobox class="mr-3"
                                                                            v-model="filterForm['metadata']['doc_language_skill']"
                                                                            :items="docLanguageSkills" item-value="cod"
                                                                            item-text="name" outlined dense
                                                                            hide-details="true" solo>
                                                                        </v-combobox>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Relación
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-combobox
                                                                            v-model="filterForm['metadata']['writer_relationship']"
                                                                            :items="writerRelationships"
                                                                            item-value="cod" item-text="name" outlined
                                                                            dense hide-details="true" solo>
                                                                        </v-combobox>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row no-gutters justify="start">
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Edad
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-combobox class="mr-3"
                                                                            v-model="filterForm['metadata']['age_range']"
                                                                            :items="ageRanges" item-value="cod"
                                                                            item-text="name" outlined dense
                                                                            hide-details="true" solo>
                                                                        </v-combobox>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Edad 2
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-combobox
                                                                            v-model="filterForm['metadata']['age_range_2']"
                                                                            :items="ageRanges2" item-value="cod"
                                                                            item-text="name" outlined dense
                                                                            hide-details="true" solo>
                                                                        </v-combobox>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-container>

                                                        <!--UNITS SECTION-->
                                                        <v-container v-if="searchFilter['id'] === 'units'"
                                                            class="filter-color pa-0" fluid>
                                                            <v-card class="filter-row-color my-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters justify="start">
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-row no-gutters justify="start">
                                                                            <v-col cols="12">
                                                                                Tipo de subacto
                                                                            </v-col>
                                                                            <v-col cols="auto" class="ml-6">
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSSD']"
                                                                                    label="SSD"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSSS']"
                                                                                    label="SSS"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSSTop']"
                                                                                    label="SSTop"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSSX']"
                                                                                    label="SSX"></v-checkbox>
                                                                            </v-col>
                                                                            <v-col cols="auto ml-10">
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAT']"
                                                                                    label="SAT"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAT_M']"
                                                                                    label="SAT/M"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAT_I']"
                                                                                    label="SAT/I"></v-checkbox>
                                                                                <!--                                                                                ----
                                                                                <v-checkbox dense hide-details="true" v-model="filterForm['units']['subactsSS_SSA']" label="SS/SA"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true" v-model="filterForm['units']['subactsSAX']" label="SAX"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true" v-model="filterForm['units']['residue']" label="Residuo"></v-checkbox>-->
                                                                            </v-col>
                                                                            <v-col cols="auto ml-10">
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAM']"
                                                                                    label="SAM"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAM_T']"
                                                                                    label="SAM/T"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAM_I']"
                                                                                    label="SAM/I"></v-checkbox>
                                                                            </v-col>
                                                                            <v-col cols="auto ml-10">
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAI']"
                                                                                    label="SAI"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAI_T']"
                                                                                    label="SAI/T"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAI_M']"
                                                                                    label="SAI/M"></v-checkbox>
                                                                            </v-col>
                                                                            <v-col cols="auto ml-10">
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSS_SSA']"
                                                                                    label="SS/SA"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAX']"
                                                                                    label="SAX"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['residue']"
                                                                                    label="Residuo"></v-checkbox>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-container>
                                                    </v-tab-item>
                                                </v-tabs-items>

                                                <v-row no-gutters justify="end">
                                                    <v-col cols="auto">
                                                        <v-btn class="mr-3" color="white"
                                                            @click="doSearch(); filters_dialog = false;" small>
                                                            Filtrar
                                                        </v-btn>
                                                        <v-btn class="mr-3" color="white"
                                                            @click="resetFilterSection(selected_entity_tab.replace('tab-', ''));"
                                                            small>
                                                            Borrar
                                                        </v-btn>
                                                        <v-btn class="mr-3" color="white"
                                                            @click="filters_dialog = false;" small>
                                                            Cerrar
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-dialog>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <!-- SEARCH RESULTS SECTION -->
        <v-container v-if="search_text && search_text.length > 0">
            <v-row justify="start">
                <v-col :cols="result_card_cols" class="pa-3">
                    <!--style="width:70%"-->
                    <!-- RESULT SECTION -->
                    <v-card id="resultsCard" class="item-card">
                        <v-card outlined class="filter-row-color my-3 pa-1">
                            <v-row no-gutters justify="start">
                                <v-col v-if="!loading_results" class="pa-1 pt-2" cols="auto">
                                    <!--Encontrados {{result_items?result_items.length:0}} resultados en {{result_corpus_document_count}} conversaciones al buscar por <span style="color: red">"{{search_text}}"</span>-->
                                    Encontrados {{ result_tokens_count }} ejemplos en
                                    {{ result_items ? result_items.length : 0 }}
                                    movimientos en {{ result_corpus_document_count }} documentos al buscar por
                                    <span style="color: darkorchid">"{{ search_text }}"</span>
                                </v-col>
                                <v-col v-if="loading_results" class="pa-1 pt-2" cols="auto">
                                    Buscando en el corpus...
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col v-if="selected_rows.length > 0" class="pa-1" cols="auto">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                @click="generateResultDoc(selected_rows)">mdi-file-word</v-icon>
                                        </template>
                                        "Descargar resultados seleccionados en word"
                                    </v-tooltip>
                                </v-col>
                                <v-col v-if="selected_rows.length > 0" class="pa-1" cols="auto">

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                @click="generateResultExcel(selected_rows)">mdi-file-excel</v-icon>
                                        </template>
                                        "Descargar resultados seleccionados en excel"
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-card>

                        <!-- RESULT DATA TABLE -->
                        <v-data-table class="transparent elevation-2" item-key="cod" v-model="selected_rows"
                            :headers="result_headers" :items="result_items" :items-per-page="20" locale="es-ES"
                            :expanded.sync="expanded" single-expand @item-expanded="loadMovementDetails" show-select
                            :loading="loading_results" loading-text="Cargando datos..."
                            no-data-text="No se han encontrado resultados" dense :options.sync="pagination"
                            :footer-props="{
                                itemsPerPageOptions: [10, 20, 30],
                                'items-per-page-text': 'movimientos por página'
                            }">

                            <template v-slot:item="{ item, index, expand, isExpanded }">
                                <tr :id="'row_' + item['cod']"
                                    :class="item['is_observation'] ? 'observation' : item.is_direct_speech ? 'directSpeech' : ''"
                                    :key="item.cod">
                                    <!--@click="checkSelected(item)"-->
                                    <td class="text-start body-1" style="width:1px;min-width:1px;padding: 0 12px;">
                                        <v-checkbox v-model="selected_rows" :value="item" style="margin:0px;padding:0px"
                                            hide-details @change="checkSelected(item)"></v-checkbox>
                                    </td>
                                    <td class="text-xs-left">
                                        <v-btn small text icon @click="expand(!isExpanded)">
                                            <v-icon color="primary" v-if="isExpanded">mdi-chevron-down</v-icon>
                                            <v-icon color="orange" v-else>mdi-chevron-right</v-icon>
                                        </v-btn>
                                    </td>
                                    <td v-show="$env.type != 'PRODUCTION'" class="text-center">
                                        {{ item.cod }}
                                    </td>
                                    <td class="text-center body-1">
                                        {{ item["corpus_document"]["name"] }}
                                    </td>
                                    <td class="text-center body-1">
                                        {{ item["corpus_document"]["is_segmented"] ? "Sí" : "No" }}
                                    </td>
                                    <!-- <td style="font-family: monospace !important;" class="text-center body-1"
                                        v-html="item.corpus_document_writer">
                                    </td> -->
                                    <td class="text-left body-1">
                                        <span v-if="debugTextSearch">*{{ item["cod"] }}*</span>
                                        <div class="interv-contents" v-html="highlight(item)">
                                        </div>
                                        <span v-if="debugTextSearch">*{{ item["search_data"] ?
                                            item["search_data"]["doc_tokens_parsed"].toString() : "" }}*</span>
                                    </td>
                                    <td class="text-xs-left">
                                        <v-btn small text icon @click="loadContextPanel(item)">
                                            <v-icon color="primary"
                                                v-if="hasContextPanel(item)">mdi-eye-settings</v-icon>
                                            <v-icon color="gray" v-else>mdi-eye-settings</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td style="padding:0" :colspan="headers.length">
                                    <v-card v-if="item" width="100%" height="60">
                                        <!--More info about {{ item.cod }}--asdfasd-->
                                        <v-container justify-center grid-list-xl fluid>
                                            <v-layout row wrap>
                                                <v-flex class="row-padding" xs12>
                                                    <v-row no-gutters justify="center">
                                                        <v-col cols="auto">
                                                            <v-row no-gutters justify="center">
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card>
                                </td>
                            </template>

                            <template v-slot:[`footer.page-text`]="items"> {{ items.pageStart }} - {{ items.pageStop }}
                                de {{ items.itemsLength }} </template>
                        </v-data-table>
                    </v-card>
                </v-col>
                <v-col :cols="detail_card_cols" class="pa-3">
                    <!--style="width:30%"-->
                    <!-- CONTEXT DETAILS -->
                    <v-card id="contextCard" class="item-card" v-show="detail_items && result_card_cols === 7">
                        <v-container fluid class="filter-color pa-0">
                            <v-card outlined class="filter-row-color my-3 pa-1">
                                <v-row no-gutters justify="end">
                                    <v-col class="pa-1 pt-2" cols="auto">
                                        Ampliar contexto en
                                    </v-col>
                                    <v-col class="mt-2" cols="1">
                                        <v-text-field v-model="context_ratio" outlined hide-details="true"
                                            @keydown.enter="loadMovementContextGrid" solo dense>
                                        </v-text-field>
                                    </v-col>
                                    <v-col class="pa-1 pt-2" cols="auto">
                                        movimientos
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col class="mr-auto pl-2" cols="auto">
                                        <v-row no-gutters justify="start">
                                            <v-col
                                                v-if="itemWithSelectedContext && itemWithSelectedContext['corpus_document']['is_segmented']"
                                                class="pa-1 pt-1" cols="auto">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on"
                                                            @click="visualization_dialog = true">mdi-eye-settings</v-icon>
                                                    </template>
                                                    "Opciones de visualización"
                                                </v-tooltip>
                                            </v-col>
                                            <v-dialog v-model="visualization_dialog" max-width="650">
                                                <!-- FILTERS SECTION -->
                                                <v-container class="pa-0" fluid>
                                                    <!--style="width:650px"-->
                                                    <v-row no-gutters justify="center">
                                                        <v-col cols="12" class="pa-0">
                                                            <v-card class="pa-5 filter-color">
                                                                <v-card-title class="filter-color py-0"
                                                                    style="min-height:10px" hide-actions dense>
                                                                    <h3 class="filter-color font-weight-bold text-center"
                                                                        style="line-height:10px">
                                                                        Opciones de visualización
                                                                    </h3>
                                                                </v-card-title>

                                                                <v-card-text class="filter-color pa-0 ma-0"
                                                                    style="padding:0px !important;font-size:90%">
                                                                    <!--UNITS VISUALIZATION SECTION-->
                                                                    <v-container v-if="itemWithSelectedContext"
                                                                        class="filter-color pa-0" fluid>
                                                                        <v-card
                                                                            class="filter-row-color my-3 search-value-col"
                                                                            outlined>
                                                                            <v-row no-gutters justify="start">
                                                                                <v-col class="search-value-col mr-12"
                                                                                    cols="auto">
                                                                                    <v-checkbox dense
                                                                                        hide-details="true"
                                                                                        v-model="visualizationForm['units']['movements']"
                                                                                        label="Movimientos"></v-checkbox>
                                                                                    <v-checkbox
                                                                                        v-if="itemWithSelectedContext['corpus_document']['is_segmented']"
                                                                                        dense hide-details="true"
                                                                                        v-model="visualizationForm['units']['act_groups']"
                                                                                        label="Grupo de actos"></v-checkbox>
                                                                                </v-col>
                                                                                <v-col class="search-value-col mr-12"
                                                                                    cols="auto">
                                                                                    <!--<v-checkbox dense hide-details="true" v-model="visualizationForm['units']['turns']" label="Turnos"></v-checkbox>-->
                                                                                    <v-checkbox
                                                                                        v-if="itemWithSelectedContext['corpus_document']['is_segmented']"
                                                                                        dense hide-details="true"
                                                                                        v-model="visualizationForm['units']['acts']"
                                                                                        label="Actos"></v-checkbox>
                                                                                    <v-checkbox
                                                                                        v-if="itemWithSelectedContext['corpus_document']['is_segmented']"
                                                                                        dense hide-details="true"
                                                                                        v-model="visualizationForm['units']['subacts']"
                                                                                        label="Subacts"></v-checkbox>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card>
                                                                    </v-container>

                                                                    <v-row no-gutters justify="end">
                                                                        <v-col cols="auto">
                                                                            <v-btn class="mr-3" color="white"
                                                                                @click="loadMovementContextGrid(); visualization_dialog = false;"
                                                                                small>
                                                                                Filtrar
                                                                            </v-btn>
                                                                            <v-btn class="mr-3" color="white"
                                                                                @click="resetVisualizationSection();"
                                                                                small>
                                                                                Borrar
                                                                            </v-btn>
                                                                            <v-btn class="mr-3" color="white"
                                                                                @click="visualization_dialog = false;"
                                                                                small>
                                                                                Cerrar
                                                                            </v-btn>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-card-text>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-dialog>
                                            <v-col class="pa-1 pt-1" cols="auto">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on"
                                                            @click="generateDetailsDoc()">mdi-file-word</v-icon>
                                                    </template>
                                                    "Descargar ejemplo en word"
                                                </v-tooltip>
                                            </v-col>
                                            <v-col class="pa-1 pt-1" cols="auto">

                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on"
                                                            @click="generateDetailsExcel()">mdi-file-excel</v-icon>
                                                    </template>
                                                    "Descargar ejemplo en excel"
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <!-- CONTEXT DATA TABLE -->
                            <v-row no-gutters justify="end">
                                <v-col class="pa-1 pt-2" cols="12">
                                    <v-data-table class="transparent elevation-2" item-key="cod"
                                        v-model="selected_details" :headers="detail_headers" :items="detail_items"
                                        locale="es-ES" :loading="loading_details" loading-text="Cargando datos..."
                                        no-data-text="No hay ningún resultado seleccionado."
                                        :items-per-page="detail_items.length" allowColumnResizing dense
                                        hide-default-footer>

                                        <template v-slot:item="{ item, index, expand, isExpanded }">
                                            <tr :id="'row_' + item['cod']"
                                                :class="item['is_observation'] ? 'observation' : item['highlight'] ? 'context-axis' : ''"
                                                :key="item.cod">
                                                <td class="text-center body-1" v-html="item['cod']">
                                                </td>
                                                <!-- <td style="font-family: monospace !important;"
                                                    class="text-center body-1" v-html="item.corpus_document_speaker">
                                                </td> -->
                                                <td class="text-left body-1">
                                                    <div class="interv-contents" v-html="highlight(item)"></div>
                                                </td>
                                            </tr>
                                        </template>

                                        <template v-slot:[`footer.page-text`]="items"> {{ items.pageStart }} - {{
                                            items.pageStop }} de {{ items.itemsLength }} </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import api from '@/restApi';
import { saveAs } from 'file-saver';
import { Loading } from '@/components';
import { WidthType, BorderStyle, Document, Paragraph, Packer, TextRun, Table, TableRow, TableCell, HeadingLevel, ShadingType, AlignmentType } from "docx";
import moment from 'moment';
import ExcelJS from 'exceljs';

export default {
    name: 'letter-search',
    components: {
        Document, Paragraph, Packer, TextRun, Table, TableRow, TableCell, HeadingLevel, ShadingType, saveAs, BorderStyle, WidthType, AlignmentType,
        [Loading.name]: Loading
    },
    props: {
    },
    data() {
        return {
            debugTextSearch: false,
            player: null,
            // Tabs management
            visualization_dialog: false,
            filters_dialog: false,
            selected_entity_tab: "tab-options",
            search_words: "calle",
            search_regex: "",
            search_regex_default: "(?<=\\b)(?<![àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ])$text(?=\\s|$|\\.|\\:|,|-|\\¿|\\?|¡|!|\\/|↑|↓|→|º|[|]|\\(|\\)|<)",
            search_text: undefined,
            context_ratio: 2,
            alternate: true,
            audio_is_loading: true,
            selected_result_item: null,
            expanded: [],
            documents: [],
            corpusDocumentTypes: [],
            professions: [],
            instructionLevels: [],
            educationalLevels: [],
            docLanguageSkills: [],
            writerRelationships: [],
            ageRanges: [],
            ageRanges2: [],
            selected_rows: [],
            selected_details: [],
            search_filters: [
                {
                    id: "options",
                    name: 'Opciones',
                    icon: "mdi-access-point"
                },
                {
                    id: "metadata",
                    name: 'Metadatos',
                    icon: "record_voice_over"
                },
                {
                    id: "units",
                    name: 'Unidades',
                    icon: "font_download"
                }
            ],
            visualizationForm: {
                units: {
                    movements: false,
                    act_groups: false,
                    acts: false,
                    subacts: false
                }
            },
            filterForm: {
                options: {
                    token_mode: "shape",
                    capital_mode: undefined,
                    accents: undefined,
                    preceded: undefined,
                    filter_position_char: undefined
                },
                metadata: {
                    corpus_document: undefined,
                    corpus_document_type: undefined,
                    year_init: undefined,
                    year_end: undefined,
                    profession: undefined,
                    instruction_level: undefined,
                    doc_language_skill: undefined,
                    writer_relationship: undefined,
                    educational_level: undefined,
                    age_range: undefined,
                    age_range_2: undefined,
                    genre: undefined,
                },
                units: {
                    subactsSSD: false,
                    subactsSSS: false,
                    subactsSSTop: false,
                    subactsSSX: false,
                    subactsSAT: false,
                    subactsSAI: false,
                    subactsSAX: false,
                }
            },
            result_headers: [
                {
                    text: "",
                    sortable: false
                },
                {
                    text: "COD",
                    sortable: false,
                    value: "cod",
                    width: 110
                },
                {
                    text: "Doc",
                    align: "center",
                    value: "corpus_document.name",
                    width: 90
                },
                {
                    text: "Seg",
                    align: "center",
                    value: "corpus_document.is_segmented",
                    width: 90
                },
                // {
                //     text: "Habl.",
                //     align: "center",
                //     value: "speaker",
                //     sortable: false,
                //     width: 100
                // },
                //                    {
                //                        text: "Id",
                //                        align: "start",
                //                        sortable: "false",
                //                        value: "cod"
                //                    },
                {
                    text: "Contenido",
                    align: "center",
                    value: "formatted_contents"
                },
                {
                    text: "",
                    sortable: false,
                    width: 60
                }
            ],
            loading_results: false,
            loading_details: false,
            result_items: [],
            result_corpus_document_count: 0,
            detail_headers: [],
            detail_headers_default: [
                {
                    text: "Cod",
                    align: "center",
                    value: "cod",
                    width: 120,
                    sortable: false
                },
                // {
                //     text: "Habl.",
                //     align: "center",
                //     value: "speaker",
                //     sortable: false,
                //     width: 120
                // },
                {
                    text: "Contenido",
                    align: "center",
                    value: "formatted_contents",
                    sortable: false
                }
            ],
            detail_items: [],
            word_types: [
                "Abreviatura",
                "Adjetivo",
                "Adverbio",
                //                    "Cifra",
                "Conjunción",
                "Determinante",
                "Expresión adjetiva",
                //                    "Fecha",
                //                    "Hora",
                "Interjección",
                "No Categorizada",
                "Pronombre",
                "Palabra cortada",
                //                    "Pausa",
                "Preposición",
                "Sigla",
                //                    "Signo de puntuación",
                "Sustantivo",
                "Verbo"
            ],
            numbers: [
                "Singular",
                "Plural",
                "Plural/Singular"
            ],
            genres: [
                "Femenino",
                "Masculino",
                "Masculino/Femenino",
                "Masculino/Femenino/Neutro",
                "Masculino/Neutro",
                "Neutro"
            ],
            persons: [
                "1ª persona del singular",
                "2ª persona del singular",
                "3ª persona del singular",
                "1ª persona del plural",
                "2ª persona del plural",
                "3ª persona del plural"
            ],
            tenses: [
                "Copretérito",
                "Copretérito en -se",
                "Futuro",
                "Pospretérito",
                "Presente",
                "Presente/Pretérito",
                "Pretérito"
            ],
            moods: [
                "Gerundio",
                "Indicativo",
                "Imperativo",
                "Imperativo/Indicativo",
                "Imperativo/Subjuntivo",
                "Infinitivo",
                "Participio",
                "Subjuntivo"
            ],
            sust_types: [
                "Común",
                "Propio"
            ],
            pronom_types: [
                "Comparativo",
                "Cuantificador",
                "Demostrativo",
                "Distributivo",
                "Exclamativo o interrogativo",
                "Globalizador",
                "Indefinido",
                "Numeral cardinal",
                "Numeral ordinal",
                "Numeral partitivo",
                "Personal",
                "Posesivo",
                "Reflexivo",
                "Relativo"
            ],
            pronom_subtypes: [
                "Acusativo",
                "Acusativo/Predicativo",
                "Dativo",
                "Dativo/Medio",
                "Nominativo",
                "Nominativo/Preposicional",
                "Singular preposicional"
            ],
            det_types: [
                "Artículo determinado",
                "Artículo indeterminado",
                "Comparativo",
                "Cuantificador",
                "Demostrativo",
                "Exclamativo o interrogativo",
                "Distributivo",
                "Globalizador",
                "Indefinido",
                "Numeral cardinal",
                "Numeral ordinal",
                "Numeral partitivo",
                "Posesivo",
                "Reflexivo",
                "Relativo"
            ],
            itemWithSelectedContext: null,
            result_card_cols: 12,
            detail_card_cols: 5,
            pagination: {},
            result_tokens_count: 0
        };
    },
    created: function () {
        this.search_regex = this.search_regex_default;

        this.loadDocuments();
        this.loadDocumentTypes();
        this.loadProfessions();
        this.loadInstructionLevels()
        this.loadDocLanguageSkills();
        this.loadWriterRelationships();
        this.loadAgeRanges();
        this.loadAgeRanges2();
        this.loadEducationalLevels();
        //            this.doSearch();
    },
    mounted: function () {
        //            this.$validator.localize('es', this.dictionary);
    },
    watch: {
        selected_entity_tab: function () {
            this.current_search_section = "tab-general";
            //                this.doSearch();
        },
        pagination: function (item) {
            var self = this;

            self.resetContextDetails();
        }
    },
    methods: {
        speak() {
            // Create a SpeechSynthesisUtterance
            const utterance = new SpeechSynthesisUtterance("Welcome to this tutorial!");

            // Select a voice
            const voices = speechSynthesis.getVoices();
            utterance.voice = voices[0]; // Choose a specific voice

            // Speak the text
            speechSynthesis.speak(utterance);
        },
        resetContextDetails() {
            var self = this;

            self.result_card_cols = 12;
            self.detail_items = [];
            self.itemWithSelectedContext = null;
        },
        async loadContextPanel(selectedItem) {
            var self = this;

            if (self.hasContextPanel(selectedItem)) {
                self.resetContextDetails();

                return;
            }

            self.result_card_cols = 7;

            self.placeContextCard(selectedItem);

            self.itemWithSelectedContext = selectedItem;


            self.loadMovementContextGrid();
        },
        placeContextCard(selectedItem) {
            if (!selectedItem) {
                return;
            }

            var contextCard = document.getElementById("contextCard");
            var resultsCard = document.getElementById("resultsCard");
            var rowElement = document.getElementById("row_" + selectedItem['cod']);

            if (!contextCard || !resultsCard) {
                return;
            }

            const rect = rowElement.getBoundingClientRect();
            const rect2 = resultsCard.getBoundingClientRect();

            contextCard.style.top = rect.top - rect2.top + 'px';
        },
        hasContextPanel(item) {
            if (!item) {
                return false;
            }

            if (!this.itemWithSelectedContext) {
                return false;
            }

            return (this.itemWithSelectedContext["cod"] === item["cod"]);
        },
        async loadMovementDetails({ item }) {
            var isExpanding;
            var self = this;

            self.audio_is_loading = true;

            self.alternate = !self.alternate;

            //                console.log("Expanded item", item);
            //                console.log("Element", "plyr_inter_" + item["cod"]);
            //                console.log("Expanded", self.expanded)
            isExpanding = !this.$mout.array.filter(self.expanded, function (item2) {
                //                    console.log(item2["cod"], "-", item["cod"])
                return item2["cod"] === item["cod"];
            }).length > 0;
            //                console.log("EOOOOOOOOOOOOOOOOOOOOO", isExpanding)

            if (this.$mout.lang.isEmpty(item) || !isExpanding) {
                return;
            }
        },
        isSustTypeVisible() {
            return (
                this.filterForm['options']['word_type'] === "Sustantivo"
            );
        },
        isDetTypeVisible() {
            return (
                this.filterForm['options']['word_type'] === "Determinante"
            );
        },
        isPronomTypeVisible() {
            return (
                this.filterForm['options']['word_type'] === "Pronombre"
            );
        },
        isPronomSubtypeVisible() {
            return (
                this.filterForm['options']['word_type'] === "Pronombre"
            );
        },
        isPersonVisible() {
            return (
                (this.filterForm['options']['word_type'] === "Determinante" && this.filterForm['options']['type'] === "Posesivo") ||
                this.filterForm['options']['word_type'] === "Verbo" ||
                this.filterForm['options']['word_type'] === "Pronombre"
            );
        },
        isGenreVisible() {
            return (
                this.filterForm['options']['word_type'] === "Adjetivo" ||
                this.filterForm['options']['word_type'] === "Determinante" ||
                this.filterForm['options']['word_type'] === "Sustantivo" ||
                this.filterForm['options']['word_type'] === "Pronombre"
            );
        },
        isNumberVisible() {
            return (
                this.filterForm['options']['word_type'] === "Adjetivo" ||
                this.filterForm['options']['word_type'] === "Determinante" ||
                this.filterForm['options']['word_type'] === "Sustantivo" ||
                this.filterForm['options']['word_type'] === "Pronombre" ||
                this.filterForm['options']['word_type'] === "Verbo"
            );
        },
        isTenseVisible() {
            return (
                this.filterForm['options']['word_type'] === "Verbo"
            );
        },
        isMoodVisible() {
            return (
                this.filterForm['options']['word_type'] === "Verbo"
            );
        },
        async loadProfessions() {
            var queryString;

            queryString = "fields=cod,name,description&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all
            this.professions = await api.getAllItems("profession", queryString);
        },
        async loadInstructionLevels() {
            var queryString;

            queryString = "fields=cod,name,description&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all
            this.instructionLevels = await api.getAllItems("instruction_level", queryString);
        },
        async loadEducationalLevels() {
            const queryString = "fields=cod,name,description&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all educational levels
            this.educationalLevels = await api.getAllItems("educational_level", queryString);
        },
        async loadDocLanguageSkills() {
            const queryString = "fields=cod,name,description&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all language skills
            this.docLanguageSkills = await api.getAllItems("doc_language_skill", queryString);
        },
        async loadWriterRelationships() {
            const queryString = "fields=cod,name,description&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all writer relationships
            this.writerRelationships = await api.getAllItems("speaker_relationship", queryString);
        },
        async loadAgeRanges() {
            const queryString = "fields=cod,name,description&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all age ranges
            this.ageRanges = await api.getAllItems("age_range", queryString);
        },
        async loadAgeRanges2() {
            const queryString = "fields=cod,name,description&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all
            this.ageRanges2 = await api.getAllItems("age_range_2", queryString);
        },
        async loadDocuments() {
            var queryString;

            queryString = "fields=cod,name&sort={\"field\":\"name\",\"dir\":\"asc\"}";

            // Get all age ranges 2
            this.documents = await api.getAllItems("corpus_document", queryString);
        },
        async loadDocumentTypes() {
            var queryString;

            queryString = "fields=cod,name&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all document types
            this.corpusDocumentTypes = await api.getAllItems("corpus_document_type", queryString);
        },
        async doSearch() {
            var self = this;

            if (!this.search_words) {
                return;
            }

            self.resetContextDetails();

            this.search_text = this.search_words;
            //                console.log("Searching by", this.selected_entity_tab);

            this.result_items = [];
            this.detail_items = [];

            this.loading_results = true;
            //                this.loading_details = true;

            this.searchMovements();
        },
        async searchMovements() {
            var fields, sort, populate, queryString;
            var segmentationOptions;
            var corpus_documentsMap;
            var debug;
            var self = this;

            // Reset selection
            self.selected_rows = [];

            queryString = self.createQueryString();

            segmentationOptions = "";

            fields = "cod,corpus_document,corpus_document_writer,formatted_contents,is_observation,is_direct_speech,search_data,movement_number,movement_key";
            populate = "corpus_document_writer.corpus_document.cod,corpus_document_writer.corpus_document.name,corpus_document_writer.corpus_document.is_segmented,corpus_document_writer.corpus_document.corpus_document_type";
            sort = "{\"field\":\"order\",\"dir\":\"asc\"}";

            queryString += "&populate=" + populate;
            if (!self.$mout.lang.isEmpty(fields)) {
                queryString += "&fields=" + fields;
            }
            queryString += "&sort=" + sort + "&pageSize=0";

            if (self.debugTextSearch) {
                self.search_regex = "$text(?=\\s|$|\\.|\\:|,|-|\\¿|\\?|¡|!|\\/|↑|↓|→|º|[|]|\\(|\\))";
            } else {
                self.search_regex = self.search_regex_default;
            }

            debug = "";
            if (this.debugTextSearch) {
                debug = "&is_debug=true";
            }

            queryString += "&regex=" + encodeURI(self.search_regex) + "&segmentation_options=" + segmentationOptions + debug;


            // Get all movements
            const response = await api.searchMovements(queryString);

            // console.log(response)

            // Get interventions
            this.result_items = response["data"];

            self.result_tokens_count = 0;

            corpus_documentsMap = {};
            for (var i in self.result_items) {
                self.result_items[i]["highlight"] = true;

                if (self.result_items[i]["search_data"]) {
                    self.result_tokens_count += self.result_items[i]["search_data"]["doc_tokens_parsed"].length;
                }

                if (self.$mout.lang.isEmpty(corpus_documentsMap[self.result_items[i]["corpus_document"]["cod"]])) {
                    corpus_documentsMap[self.result_items[i]["corpus_document"]["cod"]] = 0;
                } else {
                    corpus_documentsMap[self.result_items[i]["corpus_document"]["cod"]]++;
                }
            }

            self.result_corpus_document_count = self.$mout.object.keys(corpus_documentsMap).length;

            self.loading_results = false;
        },
        createQueryString() {
            var queryString, subactTypeFilter;
            var self = this;

            queryString = "search=" + self.search_text;

            // Format options filter
            if (self.filterForm["options"]["token_mode"]) {
                queryString += "&token_mode=" + self.filterForm["options"]["token_mode"];
            }
            if (self.filterForm["options"]["capital_mode"]) {
                queryString += "&capital_mode=" + self.filterForm["options"]["capital_mode"];
            }
            if (self.filterForm["options"]["accents"]) {
                queryString += "&accents=" + self.filterForm["options"]["accents"];
            }
            if (self.filterForm["options"]["filter_position"]) {
                queryString += "&filter_position=" + self.filterForm["options"]["filter_position"];
            }
            if (self.filterForm["options"]["filter_position_char"]) {
                queryString += "&filter_position_char=" + self.filterForm["options"]["filter_position_char"];
            }
            if (self.filterForm["options"]["word_type"]) {
                queryString += "&word_type=" + self.filterForm["options"]["word_type"];
            }
            if (self.filterForm["options"]["type"]) {
                queryString += "&type=" + self.filterForm["options"]["type"];
            }
            if (self.filterForm["options"]["subtype"]) {
                queryString += "&subtype=" + self.filterForm["options"]["subtype"];
            }
            if (self.filterForm["options"]["person"]) {
                queryString += "&person=" + self.filterForm["options"]["person"];
            }
            if (self.filterForm["options"]["genre"]) {
                queryString += "&genre=" + self.filterForm["options"]["genre"];
            }
            if (self.filterForm["options"]["number"]) {
                queryString += "&number=" + self.filterForm["options"]["number"];
            }
            if (self.filterForm["options"]["mood"]) {
                queryString += "&mood=" + self.filterForm["options"]["mood"];
            }
            // Format metadata filter
            if (self.filterForm["metadata"]["corpus_document"]) {
                queryString += "&conv=" + self.filterForm["metadata"]["corpus_document"];
            }
            if (self.filterForm["metadata"]["corpus_document_type"]) {
                queryString += "&corpus_document_speaker.corpus_document.corpus_document_type.cod=" + self.filterForm["metadata"]["corpus_document_type"];
            }
            if (self.filterForm["metadata"]["profession"]) {
                queryString += "&corpus_document_speaker.profession.cod=" + self.filterForm["metadata"]["profession"]["cod"];
            }
            if (self.filterForm["metadata"]["instruction_level"]) {
                queryString += "&corpus_document_speaker.instruction_level.cod=" + self.filterForm["metadata"]["instruction_level"]["cod"];
            }
            if (self.filterForm["metadata"]["doc_language_skill"]) {
                queryString += "&corpus_document_speaker.doc_language_skill.cod=" + self.filterForm["metadata"]["doc_language_skill"]["cod"];
            }
            if (self.filterForm["metadata"]["writer_relationship"]) {
                queryString += "&corpus_document_speaker.writer_relationship.cod=" + self.filterForm["metadata"]["writer_relationship"]["cod"];
            }
            if (self.filterForm["metadata"]["educational_level"]) {
                queryString += "&corpus_document_speaker.educational_level.cod=" + self.filterForm["metadata"]["educational_level"]["cod"];
            }
            if (self.filterForm["metadata"]["age_range"]) {
                queryString += "&corpus_document_speaker.age_range.cod=" + self.filterForm["metadata"]["age_range"]["cod"];
            }
            if (self.filterForm["metadata"]["age_range_2"]) {
                queryString += "&corpus_document_speaker.age_range_2.cod=" + self.filterForm["metadata"]["age_range_2"]["cod"];
            }
            if (self.filterForm["metadata"]["genre"]) {
                queryString += "&corpus_document_speaker.genre=" + self.filterForm["metadata"]["genre"];
            }
            if (self.filterForm["metadata"]["year_init"]) {
                queryString += "&year_init=" + self.filterForm["metadata"]["year_init"];
            }
            if (self.filterForm["metadata"]["year_end"]) {
                queryString += "&year_end=" + self.filterForm["metadata"]["year_end"];
            }

            subactTypeFilter = "";
            if (self.filterForm["units"]["subactsSAX"]) {
                subactTypeFilter += "SAX,";
            }
            if (self.filterForm["units"]["subactsSAT_M"]) {
                subactTypeFilter += "SAT_M,";
            }
            if (self.filterForm["units"]["subactsSAT_I"]) {
                subactTypeFilter += "SAT_I,";
            }
            if (self.filterForm["units"]["subactsSAM_T"]) {
                subactTypeFilter += "SAM_T,";
            }
            if (self.filterForm["units"]["subactsSAI"]) {
                subactTypeFilter += "SAI,";
            }
            if (self.filterForm["units"]["subactsSAI_T"]) {
                subactTypeFilter += "SAI_T,";
            }
            if (self.filterForm["units"]["subactsSSX"]) {
                subactTypeFilter += "SSX,";
            }
            if (self.filterForm["units"]["subactsSAM_I"]) {
                subactTypeFilter += "SAM_I,";
            }
            if (self.filterForm["units"]["subactsSAI_M"]) {
                subactTypeFilter += "SAI_M,";
            }
            if (self.filterForm["units"]["subactsSS_SSA"]) {
                subactTypeFilter += "SS_SA,";
            }
            if (self.filterForm["units"]["residue"]) {
                subactTypeFilter += "residue,";
            }
            if (self.filterForm["units"]["subactsSSS"]) {
                subactTypeFilter += "SSS,";
            }
            if (self.filterForm["units"]["subactsSAI"]) {
                subactTypeFilter += "SAI,";
            }
            if (self.filterForm["units"]["subactsSAM"]) {
                subactTypeFilter += "SAM,";
            }
            if (self.filterForm["units"]["subactsSS_SA"]) {
                subactTypeFilter += "SS_SA,";
            }
            if (self.filterForm["units"]["subactsSSTop"]) {
                subactTypeFilter += "SSS_Top,";
            }
            if (self.filterForm["units"]["subactsSAT"]) {
                subactTypeFilter += "SAT,";
            }
            if (self.filterForm["units"]["subactsSSD"]) {
                subactTypeFilter += "SSD";
            }
            if (!self.$mout.lang.isEmpty(subactTypeFilter)) {
                //                    console.log(subactTypeFilter)
                subactTypeFilter = self.$mout.string.rtrim(subactTypeFilter, ",");
                queryString += "&subact_type=" + subactTypeFilter;
            }

            return queryString;
        },
        highlight(item) {
            var contents;
            var searchText, regexString;
            var searchFilter;
            var toneChar, wordBoundaryCharPreffix, wordBoundaryCharSuffix;
            var self = this;

            contents = item["formatted_contents"];

            searchText = self.search_text;

            if (self.$mout.lang.isEmpty(searchText) || !item["highlight"]) {
                return contents;
            }

            regexString = self.search_regex_default;

            //                console.log(item["cod"] + regexString);

            wordBoundaryCharPreffix = regexString.substring(0, regexString.indexOf(")$text", 20) + 1);
            wordBoundaryCharSuffix = regexString.substring(regexString.lastIndexOf("(?"), regexString.length);

            //                console.log("Prefix:", wordBoundaryCharPreffix)
            //                console.log("Suffix:", wordBoundaryCharSuffix)

            // If there is search data
            if (!this.$mout.lang.isEmpty(item["search_data"])) {
                searchFilter = "";
                for (var i in item["search_data"]["doc_tokens_parsed"]) {
                    searchText = self.escapeRegExp(item["search_data"]["doc_tokens_parsed"][i]);

                    if (!this.$mout.lang.isEmpty(toneChar)) {
                        searchFilter += wordBoundaryCharPreffix + "" + searchText + toneChar + "|";
                        searchFilter += wordBoundaryCharPreffix + "" + searchText + "." + toneChar + "|";
                        searchFilter += wordBoundaryCharPreffix + "" + searchText + ".." + toneChar + "|";
                        searchFilter += wordBoundaryCharPreffix + "" + searchText + "..." + toneChar + "|";
                    } else {
                        searchFilter += wordBoundaryCharPreffix + searchText + wordBoundaryCharSuffix + "|";
                    }
                }

                searchFilter = this.$mout.string.rtrim(searchFilter, "|");
                //                    searchFilter = searchFilter.substring(0, searchFilter.length - 1);
            } else {
                if (!this.$mout.lang.isEmpty(toneChar)) {
                    searchFilter = wordBoundaryCharPreffix + "" + searchText + toneChar + "|";
                    searchFilter += wordBoundaryCharPreffix + "" + searchText + "." + toneChar + "|";
                    searchFilter += wordBoundaryCharPreffix + "" + searchText + ".." + toneChar + "|";
                    searchFilter += wordBoundaryCharPreffix + "" + searchText + "..." + toneChar;
                } else {
                    var regExpression = regexString.replace("$text", searchText);

                    searchFilter = regExpression;
                }
            }

            //                if (self.filterForm["options"]["filter_position"] === "preceded" ||
            //                        self.filterForm["options"]["filter_position"] === "both") {
            //                    switch (self.filterForm["options"]["filter_position_char"]) {
            //                        case "exclamation_mark":
            //                            filterPositionCondition["token.prefix"] = "¡";
            //                            break;
            //                        case "question_marks":
            //                            filterPositionCondition["token.prefix"] = "¿";
            //                            break;
            //                        case "slash":
            //                            filterPositionCondition["token.prefix"] = "/";
            //                            break;
            //                    }
            //                }
            //                if (self.filterForm["options"]["filter_position"] === "followed" ||
            //                        self.filterForm["options"]["filter_position"] === "both") {
            //                    switch (self.filterForm["options"]["filter_position_char"]) {
            //                        case "exclamation_mark":
            //                            filterPositionCondition["token.suffix"] = "!";
            //                            break;
            //                        case "question_marks":
            //                            filterPositionCondition["token.suffix"] = "?";
            //                            break;
            //                        case "slash":
            //                            filterPositionCondition["token.suffix"] = "/";
            //                            break;
            //                    }
            //                }

            ////                console.log("-------------------------");
            // console.log(item["cod"], searchFilter);
            // console.log(item["cod"], this.search_text);
            // console.log(contents);


            //                return contents.replace(new RegExp(this.search_text, "gi"), match => {
            return contents.replace(new RegExp(searchFilter, "gm"), match => {
                return '<span class="highlightText">' + match + '</span>';
            });
        },
        escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
        },
        async checkSelected(selectedItem) {
            if (this.selected_rows.length <= 0) {
                return;
            }

            //                this.updateDetailedView(selectedItem);
        },
        async loadMovementContextGrid() {
            this.detail_items = [];

            this.detail_items = await this.loadMovementContext(true);
        },
        async loadMovementContext(isForHtml) {
            var queryString;
            var fields;
            var segmentationOptions;
            var contextMovements;
            var debug;
            var self = this;

            this.loading_details = true;

            contextMovements = [];
            //                isSegmented=self.selected_result_item["is_segmented"];

            self.detail_headers = self.$mout.lang.clone(self.detail_headers_default);

            if (!self.itemWithSelectedContext["corpus_document"]["is_segmented"]) {
                self.detail_headers.splice(0, 1);
            }


            // VISUALIZATION OPTIONS
            segmentationOptions = "";

            if (self.visualizationForm["units"]["movements"]) {
                segmentationOptions += "movements,";
            }
            if (self.visualizationForm["units"]["act_groups"]) {
                segmentationOptions += "act_groups,";
            }
            if (self.visualizationForm["units"]["acts"]) {
                segmentationOptions += "acts,";
            }
            if (self.visualizationForm["units"]["subacts"]) {
                segmentationOptions += "subacts";
            }

            if (!self.$mout.lang.isEmpty(segmentationOptions)) {
                segmentationOptions = "&segmentation_options=" + self.$mout.string.rtrim(segmentationOptions, ",");
            }

            debug = "";
            if (this.debugTextSearch) {
                debug = "&is_debug=true";
            }

            // Create the query
            fields = "&fields=_id,cod,corpus_document, corpus_document_writer,formatted_contents,is_direct_speech,is_observation,movement_number,start";

            queryString = "sort={\"field\":\"order\",\"dir\":\"asc\"}&is_html=" + isForHtml + fields + segmentationOptions + debug;

            // Get movements by context
            contextMovements = await api.getMovementContext(self["itemWithSelectedContext"]["_id"], self["context_ratio"], queryString);

            for (var i in contextMovements) {
                contextMovements[i]["highlight"] = false;
                if (contextMovements[i]["cod"] === self.itemWithSelectedContext["cod"]) {
                    contextMovements[i]["highlight"] = true;
                }

                self.loading_details = false;
            }

            return contextMovements;
        },
        async resetFilters() {
            var self = this;

            self.resetFilterSection("options");
            self.resetFilterSection("metadata");
            self.resetFilterSection("units");
        },
        async resetFilterSection(section) {
            switch (section) {
                case "options":
                    this.filterForm["options"] = {
                        token_mode: "shape",
                        capital_mode: null,
                        accents: null,
                        filter_position: null,
                        filter_position_char: null,
                        word_type: null,
                        type: null,
                        subtype: null,
                        person: null,
                        genre: null,
                        number: null,
                        mood: null,
                        tense: null
                    };
                    break;
                case "metadata":
                    this.filterForm["metadata"] = {
                        corpus_document: null,
                        year_init: null,
                        year_end: null,
                        age_range: null,
                        age_range_2: null,
                        genre: null,
                        educational_level: null
                    };
                    break;
                case "units":
                    this.filterForm["units"] = {
                        speeches: false,
                        dialogs: false,
                        turns: false,
                        interventions: false,
                        acts: false,
                        subactsSSD: false,
                        subactsSSS: false,
                        subactsSSTop: false,
                        subactsSSX: false,
                        subactsSAT: false,
                        subactsSAI: false,
                        subactsSAX: false
                    };
                    break;
            }
        },
        async resetWordTypeSection() {
            this.filterForm["options"]["subtype"] = null;
            this.filterForm["options"]["type"] = null;
            this.filterForm["options"]["person"] = null;
            this.filterForm["options"]["genre"] = null;
            this.filterForm["options"]["number"] = null;
            this.filterForm["options"]["mood"] = null;
            this.filterForm["options"]["tense"] = null;
            //                console.log(this.filterForm["options"])
        },
        async resetVisualizationSection() {
            this.visualizationForm["units"] = {
                act_groups: false,
                movements: false,
                acts: false,
                subacts: false
            };
        },
        generateResultDoc(resultRows) {
            var titleText, explanationText, currentDate;
            var docObject;
            var tableRows;
            var tableCells;
            var columnWidths;
            var lines;
            var self = this;

            if (resultRows.lenght <= 0) {
                return;
            }

            currentDate = moment().locale("es").format("D MMMM YYYY");

            titleText = "Resultados de la búsqueda";
            explanationText = "Listado de " + self.result_items.length +
                " resultados encontrados en " + self.result_corpus_document_count +
                " conversaciones para el texto de búsqueda: '" + self.search_text + "'";
            //                footerText = "* Cita: Pons Bordería, Salvador (dir.) - Corpus Val.Es.Co 3.0. <https://www.valesco.es> [" + currentDate + "]";

            docObject = {
                sections: [{
                    properties: {},
                    children: [
                    ]
                }]
            };

            lines = [
                new TextRun({
                    text: titleText,
                    bold: true,
                    color: "da8d2b",
                    size: 40,
                    heading: HeadingLevel.TITLE
                })
            ];

            docObject["sections"][0]["children"].push(new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: {
                    after: 200
                },
                children: lines
            }));

            lines = [
                new TextRun({
                    text: explanationText
                })
            ];

            docObject["sections"][0]["children"].push(new Paragraph({
                alignment: AlignmentType.LEFT,
                spacing: {
                    after: 200
                },
                children: lines
            }));

            tableRows = [];
            columnWidths = [1800, 800, 1200, 5000];

            tableCells = [
                new TableCell({
                    shading: {
                        fill: "000000",
                        type: ShadingType.REVERSE_DIAGONAL_STRIPE,
                        color: "auto"
                    },
                    margins: {
                        top: 200,
                        bottom: 200,
                        left: 200,
                        right: 200
                    },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "CONVERSACIÓN",
                                    font: "Arial",
                                    size: 18,
                                    color: "da8d2b"
                                })]
                        })
                    ]
                }),
                // new TableCell({
                //     shading: {
                //         fill: "000000",
                //         type: ShadingType.REVERSE_DIAGONAL_STRIPE,
                //         color: "auto",
                //     },
                //     children: [
                //         new Paragraph({
                //             alignment: AlignmentType.CENTER,
                //             children: [
                //                 new TextRun({
                //                     text: "TIPO",
                //                     font: "Arial",
                //                     size: 18,
                //                     color: "da8d2b"
                //                 })]
                //         })
                //     ]
                // }),
                // new TableCell({
                //     shading: {
                //         fill: "000000",
                //         type: ShadingType.REVERSE_DIAGONAL_STRIPE,
                //         color: "auto",
                //     },
                //     children: [
                //         new Paragraph({
                //             alignment: AlignmentType.CENTER,
                //             children: [
                //                 new TextRun({
                //                     text: "HABLANTE",
                //                     font: "Arial",
                //                     size: 18,
                //                     color: "da8d2b"
                //                 })]
                //         })
                //     ]
                // }),
                new TableCell({
                    shading: {
                        fill: "000000",
                        type: ShadingType.REVERSE_DIAGONAL_STRIPE,
                        color: "auto",
                    },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "CONTENIDO",
                                    font: "Arial",
                                    size: 18,
                                    color: "da8d2b"
                                })]
                        })
                    ]
                })
            ];

            tableRows.push(new TableRow({
                children: tableCells
            }));

            this.$mout.array.forEach(resultRows, function (item, index, arr) {
                // var turnNumber, movementNumber, interventionKey;

                // movementNumber = item['movement_number'];

                tableCells = [
                    new TableCell({
                        children: [
                            new Paragraph({
                                text: item["corpus_document"]["name"],
                                font: "Arial",
                                size: 22,
                                alignment: AlignmentType.CENTER,
                            })
                        ]
                    }),
                    // new TableCell({
                    //     children: [
                    //         new Paragraph({
                    //             text: item["intervention_type"],
                    //             font: "Arial",
                    //             size: 22,
                    //             alignment: AlignmentType.CENTER,
                    //         })
                    //     ]
                    // }),
                    // new TableCell({
                    //     children: [
                    //         new Paragraph({
                    //             text: turnNumber + interventionKey + movementNumber,
                    //             font: "Arial",
                    //             size: 22,
                    //             alignment: AlignmentType.CENTER,
                    //         })
                    //     ]
                    // }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                text: item["formatted_contents"],
                                font: "Arial",
                                size: 22
                            })
                        ]
                    })
                ];

                tableRows.push(new TableRow({
                    children: tableCells
                }));
            });

            docObject["sections"][0]["children"].push(new Table(
                {
                    alignment: AlignmentType.CENTER,
                    columnWidths: columnWidths,
                    rows: tableRows
                }
            ));

            lines = [
                new TextRun(
                    "Pons Bordería, Salvador (dir.): "
                ),
                new TextRun({
                    text: "Corpus Val.Es.Co 3.0. ",
                    italics: true
                }),
                new TextRun({
                    text: "<https://www.valesco.es> [" + currentDate + "]"
                })
            ];

            docObject["sections"][0]["children"].push(new Paragraph({
                alignment: AlignmentType.RIGHT,
                spacing: {
                    before: 100
                },
                children: lines
            }));

            const doc = new Document(docObject);

            Packer.toBlob(doc).then((blob) => {
                //                    console.log(blob);
                saveAs(blob, "example.docx");
                //                    console.log("Document created successfully");
            });
        },
        async generateDetailsDoc() {
            var docObject;
            var currentDate;
            var detailRows;
            var self = this;

            detailRows = await self.loadMovementContext(false);

            if (detailRows.lenght <= 0) {
                return;
            }

            currentDate = moment().locale("es").format("D MMMM YYYY");

            docObject = {
                sections: [{
                    properties: {},
                    children: [
                    ]
                }]
            };

            var lines;

            lines = [];

            this.$mout.array.forEach(detailRows, function (item, index, arr) {
                // var key;
                //                    var startIndex;

                //                    console.log(index, ' : ', item);

                //                    startIndex = item['corpus_document_speaker'].indexOf("speaker_key") + 13;

                //                    key = item['corpus_document_speaker'].substring(startIndex, item['corpus_document_speaker'].indexOf("span", startIndex) - 2);
                // key = item['corpus_document_speaker']["key"];

                lines = [new TextRun({
                    text: item["formatted_contents"],
                    // text: key + ": " + item["formatted_contents"],
                    font: "Arial",
                    size: 22
                })];

                docObject["sections"][0]["children"].push(new Paragraph({
                    alignment: AlignmentType.LEFT,
                    spacing: {
                        after: 50
                    },
                    children: lines
                }));
            });

            lines = [
                new TextRun(
                    "Pons Bordería, Salvador (dir.): "
                ),
                new TextRun({
                    text: "Corpus Val.Es.Co 3.0. ",
                    italics: true
                }),
                new TextRun({
                    text: "<https://www.valesco.es> [" + currentDate + "]"
                })
            ];
            docObject["sections"][0]["children"].push(new Paragraph({
                alignment: AlignmentType.RIGHT,
                spacing: {
                    before: 200
                },
                children: lines
            }));

            const doc = new Document(docObject);

            Packer.toBlob(doc).then((blob) => {
                //                    console.log(blob);
                saveAs(blob, "example.docx");
                //                    console.log("Document created successfully");
            });
        },
        async generateResultExcel(selectedRows) {
            var titleText, explanationText, footerText, startCol, currentDate;
            var workbook;
            var worksheet;
            var rows;
            var border;
            var headerFillStyle, titleFontStyle, headerFontStyle, footerFontStyle;
            var headers;
            var startRow, col, rowNum, len;
            var self = this;

            if (selectedRows.lenght <= 0) {
                return;
            }

            currentDate = moment().locale("es").format("D MMMM YYYY");

            titleText = "Resultados de la búsqueda";
            explanationText = "Listado de " + self.result_items.length +
                " resultados encontrados en " + self.result_corpus_document_count +
                " conversaciones para el texto de búsqueda: '" + self.search_text + "'";
            footerText = "* Cita: Pons Bordería, Salvador (dir.) - Corpus Val.Es.Co 3.0. <https://www.valesco.es> [" + currentDate + "]";

            workbook = new ExcelJS.Workbook();

            workbook.created = new Date();
            workbook.modified = new Date();

            workbook.views = [
                {
                    x: 0, y: 0, width: 10000, height: 20000,
                    firstSheet: 0, activeTab: 1, visibility: 'visible'
                }
            ];

            worksheet = workbook.addWorksheet('Resultados', {
                headerFooter: { firstHeader: "Resultados de la búsqueda", firstFooter: "Corpus Valesco 3.0" }
            });

            border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            headerFillStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
            titleFontStyle = {
                name: 'Arial',
                color: { argb: 'da8d2b' },
                bold: true,
                family: 2,
                size: 14
            };
            headerFontStyle = {
                name: 'Arial',
                color: { argb: 'da8d2b' },
                family: 2,
                size: 11
            };
            footerFontStyle = {
                name: 'Arial',
                family: 2,
                size: 11,
                italic: true
            };

            worksheet.mergeCells('B2:E2');
            worksheet.getRow('2').height = 30;
            worksheet.getCell('C2').value = titleText;
            worksheet.getCell('C2').font = titleFontStyle;
            worksheet.getCell('C2').alignment = { vertical: 'middle', horizontal: 'center' };

            worksheet.mergeCells('B3:E3');
            //                worksheet.getRow('3').height = 30;
            worksheet.getCell('C3').value = explanationText;
            //                worksheet.getCell('C3').font = titleFontStyle;
            worksheet.getCell('C3').alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };

            headers = [
                { header: 'DOCUMENTO', key: 'corpus_document', width: 20, alignment: { vertical: 'middle', horizontal: 'center' } },
                // { header: 'TIPO DE\r\n MOVIMIENTO', key: 'intervention_type', width: 20, alignment: { vertical: 'middle', horizontal: 'center' } },
                // { header: 'HABLANTE', key: 'speaker', width: 15, alignment: { vertical: 'middle', horizontal: 'center' } },
                { header: 'CONTENIDO', key: 'contents', width: 100, alignment: { vertical: 'middle', horizontal: 'left', wrapText: true } }
            ];

            startCol = "B";
            startRow = 5;

            col = startCol.toUpperCase();
            rowNum = startRow;

            len = headers.length;
            for (let i = 0; i < len; i++) {
                let nameCol;
                let cell;

                cell = worksheet.getCell(col + rowNum);
                cell.value = headers[i].header;
                nameCol = worksheet.getColumn(col);

                if (headers[i].format) {
                    nameCol.numFmt = headers[i].format;
                }

                nameCol.width = headers[i].width;
                cell.height = 20;
                cell.border = border;
                cell.font = headerFontStyle;
                cell.fill = headerFillStyle;
                cell.alignment = { vertical: 'middle', horizontal: 'center' };

                col = self.nextColumn(col);
            }

            // Add an array of rows
            rows = [];

            this.$mout.array.forEach(selectedRows, function (item, index, arr) {
                // var turnNumber, interventionNumber, interventionKey;
                var excelLine;


                // interventionKey = item["intervention_key"];
                // turnNumber = item['turn_number'];
                // interventionNumber = item['movement_number'];


                excelLine = {
                    'corpus_document': item["corpus_document"]["name"],
                    // 'intervention_type': item["intervention_type"],
                    // 'speaker': turnNumber + interventionKey + interventionNumber,
                    'contents': item["formatted_contents"]
                };
                rows.push(excelLine);
            });

            // Set header row height
            const row = worksheet.lastRow;
            row.height = 35;

            for (let r of rows) {
                let cell;
                let i;

                rowNum++;
                col = startCol;
                //                    console.log("Row", r);
                //                    worksheet.getRow(rowNum).height = 30;

                i = 0;
                for (let key in r) {
                    cell = worksheet.getCell(col + rowNum);

                    cell.value = r[key];
                    cell.border = border;
                    cell.alignment = headers[i].alignment;

                    col = self.nextColumn(col);
                    i++;
                    //                        console.log("Column", r[key]);
                }
            }

            rowNum += 2;
            col = "E";

            //                console.log(startCol + rowNum + ":" + col + rowNum)

            worksheet.mergeCells(startCol + rowNum + ":" + col + rowNum);
            worksheet.getRow(rowNum).height = 20;
            worksheet.getCell(startCol + ":" + rowNum).value = footerText;
            worksheet.getCell(startCol + ":" + rowNum).font = footerFontStyle;
            worksheet.getCell(startCol + ":" + rowNum).alignment = { vertical: 'middle', horizontal: 'left' };

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                self.downloadBlob(blob, 'ejemplo.xlsx');
            });
        },
        async generateDetailsExcel() {
            var titleText, footerText, startCol, currentDate;
            var detailRows;
            var corpus_document;
            var workbook;
            var worksheet;
            var rows;
            var border;
            var headerFillStyle, titleFontStyle, headerFontStyle, footerFontStyle;
            var headers;
            var startRow, col, rowNum, len;
            var self = this;

            detailRows = await self.loadMovementContext(false);

            if (detailRows.lenght <= 0) {
                return;
            }

            corpus_document = await self.loadConversation(self.itemWithSelectedContext["name"]);

            currentDate = moment().locale("es").format("D MMMM YYYY");

            titleText = 'Extracto de la conversación ' + corpus_document["name"];
            footerText = "* Cita: Pons Bordería, Salvador (dir.) - Corpus Val.Es.Co 3.0. https://www.valesco.es> [" + currentDate + "]";

            workbook = new ExcelJS.Workbook();

            workbook.created = new Date();
            workbook.modified = new Date();

            workbook.views = [
                {
                    x: 0, y: 0, width: 10000, height: 20000,
                    firstSheet: 0, activeTab: 1, visibility: 'visible'
                }
            ];

            worksheet = workbook.addWorksheet('Ejemplo', {
                headerFooter: { firstHeader: "Extracto de la conversación", firstFooter: "Corpus Valesco 3.0" }
            });

            border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            headerFillStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
            titleFontStyle = {
                name: 'Arial',
                color: { argb: 'da8d2b' },
                bold: true,
                family: 2,
                size: 14
            };
            headerFontStyle = {
                name: 'Arial',
                color: { argb: 'da8d2b' },
                family: 2,
                size: 11
            };
            footerFontStyle = {
                name: 'Arial',
                family: 2,
                size: 11,
                italic: true
            };

            worksheet.mergeCells('C2:E2');
            worksheet.getRow('2').height = 30;
            worksheet.getCell('C2').value = titleText;
            worksheet.getCell('C2').font = titleFontStyle;
            worksheet.getCell('C2').alignment = { vertical: 'middle', horizontal: 'center' };

            headers = [
                //                    {header: 'CONVERSACIÓN', key: 'corpus_document', width: 20, alignment: {vertical: 'middle', horizontal: 'center'}},
                // { header: 'TIPO DE\r\n MOVIMIENTO', key: 'intervention_type', width: 20, alignment: { vertical: 'middle', horizontal: 'center' } },
                // { header: 'HABLANTE', key: 'speaker', width: 15, alignment: { vertical: 'middle', horizontal: 'center' } },
                { header: 'CONTENIDO', key: 'contents', width: 100, alignment: { vertical: 'middle', horizontal: 'left', wrapText: true } },
                { header: 'INICIO\r\n(ms)', key: 'start', width: 10, alignment: { vertical: 'middle', horizontal: 'center' } }
            ];

            startCol = "B";
            startRow = 4;

            col = startCol.toUpperCase();
            rowNum = startRow;

            len = headers.length;
            for (let i = 0; i < len; i++) {
                let nameCol;
                let cell;

                cell = worksheet.getCell(col + rowNum);
                cell.value = headers[i].header;
                nameCol = worksheet.getColumn(col);

                if (headers[i].format) {
                    nameCol.numFmt = headers[i].format;
                }

                nameCol.width = headers[i].width;
                cell.height = 20;
                cell.border = border;
                cell.font = headerFontStyle;
                cell.fill = headerFillStyle;
                cell.alignment = { vertical: 'middle', horizontal: 'center' };

                col = self.nextColumn(col);
            }

            // Add an array of rows
            rows = [];

            this.$mout.array.forEach(detailRows, function (item, index, arr) {
                // var turnNumber, interventionNumber, interventionKey;
                var excelLine;
                //                    console.log(index, ' : ', item);


                // interventionKey = item['corpus_document_speaker']["key"];
                // turnNumber = item['turn_number'];
                // interventionNumber = item['movement_number'];
                excelLine = {
                    //                        'corpus_document': item["corpus_document"],
                    // 'intervention_type': item["intervention_type"],
                    // 'speaker': turnNumber + interventionKey + interventionNumber,
                    'contents': item["formatted_contents"],
                    'start': item["start"]
                };
                rows.push(excelLine);
            });

            // Set header row height
            const row = worksheet.lastRow;
            row.height = 35;

            for (let r of rows) {
                let cell;
                let i;

                rowNum++;
                col = startCol;
                //                    console.log("Row", r);
                //                    worksheet.getRow(rowNum).height = 30;

                i = 0;
                for (let key in r) {
                    cell = worksheet.getCell(col + rowNum);

                    cell.value = r[key];
                    cell.border = border;
                    cell.alignment = headers[i].alignment;

                    col = self.nextColumn(col);
                    i++;
                    //                        console.log("Column", r[key]);
                }
            }

            rowNum += 2;
            col = "D";

            //                console.log(startCol + rowNum + ":" + col + rowNum)

            worksheet.mergeCells(startCol + rowNum + ":" + col + rowNum);
            worksheet.getRow(rowNum).height = 20;
            worksheet.getCell(startCol + ":" + rowNum).value = footerText;
            worksheet.getCell(startCol + ":" + rowNum).font = footerFontStyle;
            worksheet.getCell(startCol + ":" + rowNum).alignment = { vertical: 'middle', horizontal: 'left' };

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                self.downloadBlob(blob, 'ejemplo.xlsx');
            });
        },
        async loadConversation(corpus_documentName) {
            var queryString;
            var corpus_document;

            this.corpus_document_loading = true;

            queryString = "fields=name";

            // Get all corpus documents
            corpus_document = await api.getAllItems("corpus_document", corpus_documentName, queryString);

            return corpus_document[0];
        },
        nextColumn(current) {
            let alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
            return alphabet[alphabet.indexOf(current) + 1];
        },
        async downloadBlob(blob, filename) {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename;

            document.body.appendChild(link);
            link.click()
            document.body.removeChild(link);
        }
    }
};
</script>
<style scoped>
.selected {
    background-color: #fde19a !important;
}

.directSpeech tr {
    background-color: #8fbc8f5c !important;
}

.directSpeech .interv-contents {
    font-style: italic;
}

.observation {
    background-color: #d6e7ea !important;
}


.search-label-col {
    padding: 4px !important;
    padding-top: 8px !important;
}

.search-value-col {
    padding: 4px !important;
}

.v-input__slot {
    min-height: 30px !important;
}

.v-input--selection-controls {
    margin-top: 0px;
}

.headline {
    display: block;
    font-family: 'amaranth' !important;
    text-shadow: 1px 1px 1px #eaf1ea !important;
    line-height: 120% !important;
}

.filter-color {
    background-color: #FFF8E1 !important;
}

.filter-row-color {
    background-color: #FFE082 !important;
}

/*    .section-option i,span{
            color: #da8d2b;
        }*/

.section-title {
    padding: 0 0 20px 20px;
    line-height: 120%;
}

/*    .section-content{
            padding: 0 0 20px 20px;
            text-align: justify;
        }*/

.v-subheader {
    /*line-height: 50px !important;*/
    font-size: medium !important;
    /*font-weight: bold !important;*/
    color: black !important;
}

.v-tabs {
    height: 40px !important;
}

.v-expansion-panel-content__wrap {
    padding: 0 12px 12px;
}

.highlightText {
    color: darkorchid;
    /*background: yellow;*/
}

.morpho_key {
    margin-right: 5px;
    color: #f2b619;
}

.morpho_value {
    color: #fff;
}

.morpho a {
    color: steelblue !important;
}

.morpho_note {
    font-size: 80%;
    line-height: 1.2;
    align-content: center;
}

.context-axis {
    background: #ccccff;
    /*background: yellow;*/
}

.v-data-table th {
    font-size: 16px !important;
    text-transform: uppercase;
}

.v-data-table td {
    padding: 0 10px;
}

.v-data-table td p {
    margin: 3px 0;
}

.v-data-table td i {
    font-weight: 300;
}

.speaker_turn_count {
    color: #e95e38;
    font-size: 95%;
}

.speaker_key {
    color: black;
}

.speaker_int_count {
    color: cornflowerblue;
    font-size: 95%;
}

.v-data-table__wrapper {
    overflow-x: visible;
    overflow-y: visible;
}

.v-data-table td {
    padding: 0 4px;
    margin: 0 !important;
}
</style>
